import { UserSession } from './user-session';
import { Role } from './role';

export interface AuthenticatedUser {
  id?: number;
  userSession?: UserSession;
  challengeName?: string;
  sessionId?: string;
  mfaSecretCode?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  roleId?: number;
  role?: Role;
  memberTypeId?: number;
  passwordChangedDate?: string;
  lastLoginDate?: string;
  eulaAcceptedDate?: string;
  eulaAccepted?: boolean;
  active?: boolean;
  zoneId?: number;
}

export enum MemberType {
  classA = 1,
  apprentice,
  applicant,
}
